<template>
	<div>
		<van-row class="evaluate_list van-hairline--bottom" v-for="(item,i) in typeList" :key="i">
		  <van-col span="8">{{item.codeLabel}}</van-col>
		  <van-col span="16">
			  <van-rate v-model="item.evaluateResult" :size="25" allow-half void-icon="star" void-color="#eee" />
		  </van-col>
		</van-row>
		<van-field
		  v-model="remark"
		  class="remark"
		  rows="2"
		  autosize
		  label-width="6em"
		  label="意见或建议"
		  type="textarea"
		  maxlength="50"
		  placeholder="请输入意见或建议"
		  show-word-limit
		/>
		<van-checkbox v-model="anonymous" class="anonymous">匿名评价</van-checkbox>
		<div class="submitWrap">
			<van-button type="primary" class="submit" @click="handleSubmit" block>提交</van-button>
		</div>
	</div>
</template>

<script>
	import {
		reqProcessCode,
		reqEvaluateAdd
	} from '../../api'
	import { Toast } from 'vant';
	export default {
		name: "order",
		data() {
			return {
				remark: '',
				anonymous:'',
				typeList:[],
				ids:''
			}
		},
		created() {
			this.ids = this.$route.query.id;
			this.getCodeList()
		},
		mounted() {
		},
		methods: {
			onSelect(action) {
				this.typeValue = action.codeValue
				this.typeName = action.text
			},
			//获取评价类型
			getCodeList(){
				var params = {
					codeTypeValue:'repair_evaluate_type',
					companyId:this.$cookies.get('companyId')
				}
				this.typeList = []
				reqProcessCode(params).then(res=>{
					console.log(res);
					if(res.success){
						if(res.data.length>0){
							for(let i=0;i<res.data.length;i++){
								this.typeList.push({
									codeLabel:res.data[i].codeLabel,
									evaluateType:res.data[i].codeValue,
									evaluateResult:0
								})
							}
						}
					}
				})
			},
			handleSubmit(){
				console.log(this.typeList)
				for(let i=0;i<this.typeList.length;i++){
					delete this.typeList[i].codeLabel
					if(this.typeList[i].evaluateResult==0){
						Toast.fail('请选择'+this.typeList[i].codeLabel);
						return
					}
				}
				let params = {
					orderId:this.ids,
					userId:this.$cookies.get('userInfo').userId,
					anonymous: 0,
					remark:this.remark,
					details:this.typeList
				}
				if(this.anonymous){
					params.anonymous = 1
				}
				console.log(params)
				reqEvaluateAdd(params).then(res=>{
					console.log(res)
					if(res.success){
						Toast.fail({
							message:'评价完成',
							className: 'apiLoading'
						});
						this.$router.replace({
						  path:'/evaluateList',
						  name:'evaluateList'
						})
					}else {
						Toast.fail({
							message: res.msg,
							className: 'apiLoading'
						});
					}
				})
				
			}
		},
	}
</script>


<style lang="stylus" rel="stylesheet/stylus">
  @import "../../common/stylus/mixins.styl"
</style>
<style>
	.van-cell-group{
		margin-top:8px;
	}
	.van-cell{
		height: 98px !important;
		line-height: 98px;
		font-size: 30px;
		color: #222222;
		padding-left: 40px;
	}
	.van-field__control{
		text-align: right;
		padding-right: 40px;
	}
	.van-field__label{
		width: 120px;
	}
	.evaluate_list{
		background-color: #FFFFFF;
		height: 98px !important;
		line-height: 98px;
		font-size: 30px;
		color: #222222;
		padding:0 40px;
	}
	.submitWrap{
		padding: 20px;
	}
	.submit{
		font-size: 30px;
		line-height: 88px;
		height: 88px;
	}
	.remark{
		height: 300px !important;
	}
	.remark .van-field__control{
		text-align: left;
	}
	.remark .van-field__word-limit{
		font-size: 24px;
		position: absolute;
		bottom: 12px;
		right: 10px;
	}
	.anonymous{
		text-align: center;
		padding: 20px;
		line-height: 48px;
		height: 48px;
		font-size: 24px;
	}
</style>



// WEBPACK FOOTER //
// src/pages/evaluate/evaluate.vue